import auth from 'app/core/auth';
import { type InternalAxiosRequestConfig } from 'axios';
import i18Next from 'i18next';
export const authTokenInterceptor = async (config: InternalAxiosRequestConfig) => {
  const user = await auth.getUser();

  if (!config.headers) {
    config.headers = {} as any;
  }

  if (user) {
    config.headers.Authorization = `Bearer ${user.access_token}`;
  }
  config.headers['Accept-Language'] = i18Next.language;
  return config;
};
